const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL;
const CREDENTIAL_TYPE = process.env.REACT_APP_CREDENTIAL_TYPE_ID;
const SDJWT_CREDENTIAL_TYPE = process.env.REACT_APP_SDJWT_CREDENTIAL_TYPE_ID;
const ENTITY_DID = process.env.REACT_APP_ENTITY_DID;
const ENTITY_DID_KEY = process.env.REACT_APP_ENTITY_DID_KEY;

const BACKEND = {
  BASE_URL: BACKEND_BASE_URL,
};

const OIDC_ISSUANCE = {
  CREDENTIAL_TYPE,
  SDJWT_CREDENTIAL_TYPE,
  ENTITY_DID,
  ENTITY_DID_KEY,
};

export { BACKEND, OIDC_ISSUANCE };
